import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { SignupComponent } from './signup/signup.component';
import { LoginComponent } from './login/login.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MaterialModule } from './shared/material/material.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ApiInterceptor } from './core/interceptors/api.interceptor';
import { TestComponent } from './test/test.component';
import { ToastrModule } from 'ngx-toastr';
import { DecryptInterceptor } from './core/interceptors/decrypt.interceptor';
import { FlyOutNewNibedonFormComponent } from './shared/components/fly-out-new-nibedon-form/fly-out-new-nibedon-form.component';
// import { UserStatusService } from './services/user-status.service';

@NgModule({
  declarations: [AppComponent, SignupComponent, LoginComponent, TestComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    MaterialModule,
    DragDropModule,
    FlyOutNewNibedonFormComponent,
    ToastrModule.forRoot({
      toastClass: 'toast',
      positionClass: 'toast-top-right',
      disableTimeOut: false,
      closeButton: false,
      progressBar: true,
      preventDuplicates: true,
    })
  ],
  exports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    MaterialModule,
    DragDropModule,
  ],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: DecryptInterceptor,
    //   multi: true,
    // },
    // Other providers
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
